import { memo, useEffect } from 'react';
import { EventBus, useGameStore } from '@campus/core';

/**
 * ChatInput — Raccourci clavier Entrée → ouvre/ferme le chat général.
 *
 * Ne rend rien visuellement. Capture uniquement la touche Entrée
 * pour ouvrir le panneau de chat général (GeneralChat).
 */
export const ChatInput = memo(function ChatInput() {
  useEffect(() => {
    const handleKeyDown = (e: KeyboardEvent) => {
      const tag = (e.target as HTMLElement).tagName;
      if (tag === 'INPUT' || tag === 'TEXTAREA') return;
      if (useGameStore.getState().adminPage) return; // campus en arrière-plan

      if (e.key === 'Enter' || e.code === 'Enter') {
        e.preventDefault();
        EventBus.emit('ui:toggle-general-chat', {});
      }
    };

    window.addEventListener('keydown', handleKeyDown, true);
    return () => window.removeEventListener('keydown', handleKeyDown, true);
  }, []);

  // Aucun rendu — composant invisible, raccourci clavier uniquement
  return null;
});
